"use client";
import { isNextClient } from "@perk/core/lib/is-next-client";
import { useContext } from "react";

let _usePathname: null | (() => string) = null;

if (isNextClient()) {
  const { usePathname } = require("next/navigation");
  _usePathname = usePathname;
} else {
  const { useLocation, getRouterContext } = require("@tanstack/react-router");
  _usePathname = function usePathnameFallback() {
    const router = useContext(getRouterContext());
    const location = useLocation({ router });
    return location.pathname;
  };
}

export function usePathname() {
  // biome-ignore lint/style/noNonNullAssertion: <explanation>
  return _usePathname!();
}
